import React from "react";
import "./AboutCareer.scss";
import { Link } from "react-router-dom";

import { ReactComponent as SideBtn } from "../../assets/svg/side-btn.svg";

import aboutCareer1 from "../../assets/images/aboutCareer.png";

const AboutCareer = () => {
  return (
    <section className="section aboutCareer">
      <article className="aboutCareer__container container">
        <div className="aboutCareer__container--header"></div>
        <div className="aboutCareer__container--contents">
          <div className="aboutCareer__container--contents-left">
            <h3 className="contents-left-title">Career</h3>
            <figure className="contents-left-img">
              <img
                src={aboutCareer1}
                width={608}
                height={483}
                alt="HomeImpact1"
                title="Radiksez Career Image"
              />
            </figure>

            <h3 className="contents-left-subtitle">Opportunities</h3>
          </div>

          <div className="aboutCareer__container--contents-right">
            <h3>Work with Radiksez</h3>

            <p>
              Choose Radiksez to embrace your skills and passion. We are your
              growth partner, encouraging creativity and individual development
              while creating excellent user experiences in a fast-paced,
              collaborative atmosphere.
            </p>

            <Link
              to="https://www.linkedin.com/company/radiksez/"
              className="aboutCareer__contents-btn"
            >
              <button className="aboutCareer__btn">
                <span>Start your career</span>
              </button>
              <SideBtn />
            </Link>
          </div>
        </div>
      </article>
    </section>
  );
};

export default AboutCareer;
